import { CustomerIntelligenceFilters, CustomerReportType } from '../customerIntelligence/types';

export const WHATSAPP_TEMPLATE_VARIABLES = [
  { key: 'nome', label: '{{nome}}' },
  { key: 'ultima_compra', label: '{{ultima_compra}}' },
  { key: 'dias_sem_comprar', label: '{{dias_sem_comprar}}' },
  { key: 'ticket_medio', label: '{{ticket_medio}}' },
] as const;

export interface WhatsAppTemplate {
  id: number;
  title: string;
  message: string;
  createdAt: string;
}

export interface WhatsAppCampaignPreview {
  totalRecipients: number;
  totalDuplicatedPhones: number;
  totalInvalidPhones: number;
  sampleMessage: string;
}

export interface WhatsAppCampaignSendResult {
  campaignId: number;
  totalSent: number;
  totalDuplicated: number;
  totalInvalid: number;
}

export interface WhatsAppCampaignSelection {
  mode: 'all' | 'none';
  exceptionCustomerIds: number[];
}

export interface WhatsAppCampaignPayload {
  reportType: CustomerReportType;
  filters: CustomerIntelligenceFilters;
  message: string;
  selection: WhatsAppCampaignSelection;
}
